import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function selectStationDetails(state, stationId) {
    return _dataSelector(state)[stationId];
}

export {
    selectStationDetails,
};
